import React, { useEffect, useState } from "react";
import api, { ARTICLE_CATEGORIES } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Layout";
import { ArticleCard } from "@/components/ArticleCard";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Articles() {
  const [articles, setArticles] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("सभी");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const PER_PAGE = 24;

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/articles").then((res) => setArticles(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => { setPage(1); }, [q, cat]);

  const filtered = articles.filter((a) => {
    const matchQ = !q || a.title.includes(q) || (a.summary || "").includes(q) || (a.author || "").includes(q);
    const matchC = cat === "सभी" || a.category === cat;
    return matchQ && matchC;
  });
  const totalPages = Math.ceil(filtered.length / PER_PAGE) || 1;
  const paged = filtered.slice((page - 1) * PER_PAGE, page * PER_PAGE);

  return (
    <div>
      <PageHeader testId="articles-header" title="लेख" subtitle="पर्यटन, संस्कृति, विरासत एवं शोध पर हमारे लेख" />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-4 mb-8">
          <div className="relative flex-1">
            <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input data-testid="articles-search-input" value={q} onChange={(e) => setQ(e.target.value)}
              placeholder="लेख खोजें..." className="pl-10 h-11 bg-white border-amber-200" />
          </div>
          <div className="flex gap-2 flex-wrap">
            {["सभी", ...ARTICLE_CATEGORIES].map((c) => (
              <button key={c} data-testid={`articles-cat-${c}`} onClick={() => setCat(c)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  cat === c ? "bg-[#0a2540] text-white" : "bg-white border border-amber-200 text-[#0a2540] hover:bg-amber-50"
                }`}>{c}</button>
            ))}
          </div>
        </div>

        {loading ? (
          <div className="text-center py-20 text-slate-400">लोड हो रहा है...</div>
        ) : filtered.length > 0 ? (
          <>
            <p className="text-sm text-slate-500 mb-5">कुल {filtered.length} लेख</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {paged.map((a) => <ArticleCard key={a.id} article={a} />)}
            </div>
            {totalPages > 1 && (
              <div className="flex items-center justify-center gap-2 mt-12 flex-wrap" data-testid="articles-pagination">
                <button disabled={page === 1} onClick={() => { setPage(page - 1); window.scrollTo(0, 0); }}
                  className="px-4 py-2 rounded-lg border border-amber-200 bg-white text-[#0a2540] disabled:opacity-40 hover:bg-amber-50">पिछला</button>
                <span className="px-4 py-2 text-sm text-slate-600">पृष्ठ {page} / {totalPages}</span>
                <button disabled={page === totalPages} onClick={() => { setPage(page + 1); window.scrollTo(0, 0); }}
                  className="px-4 py-2 rounded-lg border border-amber-200 bg-white text-[#0a2540] disabled:opacity-40 hover:bg-amber-50">अगला</button>
              </div>
            )}
          </>
        ) : (
          <EmptyState icon="feather-pointed" message={articles.length ? "कोई लेख नहीं मिला।" : "अभी तक कोई लेख प्रकाशित नहीं हुआ है।"} />
        )}
      </section>
    </div>
  );
}
